"use client";

import {
  LandingspageData,
  StoryData,
  createLandingspageSchema,
  createStorySchema,
} from "@/storyblok/schemas";
import LandingspageStory from "@/components/stories/LandingspageStory";
import { createStoryblok } from "@/storyblok";
import { useEffect, useState } from "react";
import { registerStoryblokBridge } from "@storyblok/js";

export default function LandingspageVisualEditor(props: {
  story: StoryData<LandingspageData>;
}) {
  createStoryblok();
  const schema = createStorySchema(createLandingspageSchema());
  const [story, setStory] = useState(props.story);

  useEffect(() => {
    registerStoryblokBridge(story.id, (s) => {
      try {
        const newStory = schema.parse(s);
        setStory(newStory);
      } catch (error) {
        console.log(error);
      }
    });
  });

  return (
    <>
      <LandingspageStory story={story} />
    </>
  );
}
